import Component from 'inferno-component';
import './Gallery.css';
import './GalleryMobile.css';

const basePath = 'screenshots/';
const ESC_KEY_CODE = 27;

class Gallery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      photos: null
    };
    this.bindKeyEvents();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isVisible && nextProps.photos) {
      this.setState({ currentPhotoIndex: nextProps.currentPhotoIndex || 0, photos: nextProps.photos, loadedPhotoCount: 0 });
      this.preloadPhotos();
      this.show();
    }
  }

  bindKeyEvents = ()=> {
    document.addEventListener('keyup', (event)=> {
      if (event.keyCode === ESC_KEY_CODE) {
        this.close();
      }
    });
  }

  preloadPhotos = ()=> {
    this.state.photos.forEach((photo)=> {
      this.preloadPhoto(photo);
    });
  }

  preloadPhoto = (photo)=> {
    let img = new Image();
    img.onload = this.photoLoaded;
    img.src = basePath + photo.file;
  }

  photoLoaded = (event)=> {
    this.setState({ loadedPhotoCount: this.state.loadedPhotoCount + 1 });
  }

  show = ()=> {
    this.setState({ isVisible: true });
  }

  close = ()=> {
    this.setState({ isVisible: false });
    this.props.onClose();
  }

  onClickOutside = (event)=> {
    if (event.srcElement && event.srcElement.className === 'gallery open') {
      this.close();
    }
  }

  next = ()=> {
    let numPhotos = this.state.photos.length;
    let nextPhotoIndex = this.state.currentPhotoIndex + 1;
    if (nextPhotoIndex >= numPhotos) {
      this.setState({ currentPhotoIndex: 0 });
    } else {
      this.setState({ currentPhotoIndex: nextPhotoIndex });
    }
  }

  previous = ()=> {
    let lastPhotoIndex = this.state.photos.length - 1;
    let previousPhotoIndex = this.state.currentPhotoIndex - 1;
    if (previousPhotoIndex < 0) {
      this.setState({ currentPhotoIndex: lastPhotoIndex });
    } else {
      this.setState({ currentPhotoIndex: previousPhotoIndex });
    }
  }

  render() {
    let currentPhoto = null;
    let currentPhotoStyle = null;
    let areControlButtonsVisible = false;
    let caption = '';
    let status = <div className="status-content"><i className="icon-cog spin"></i>Loading...</div>;
    let galleryClassName = 'gallery' + (this.state.isVisible ? ' open' : '');
    if (this.state.photos && this.state.photos.length > 0) {
      currentPhoto = this.state.photos[this.state.currentPhotoIndex];
      areControlButtonsVisible = this.state.photos.length > 1;
      caption = currentPhoto.caption;
      currentPhotoStyle = 'background-image: url(' + basePath + currentPhoto.file + ');';

      if (this.state.photos.length === this.state.loadedPhotoCount) {
        status = 'Showing ' + (this.state.currentPhotoIndex + 1) + ' of ' + this.state.photos.length;
      }
    }

    return (
      <div className={ galleryClassName } onClick={ this.onClickOutside }>
        <div className="gallery-content">
          <header>
            <div className="gallery-status">{ status }</div>
            { currentPhoto && currentPhoto.project
              ? <div className="project"><span className="label">Project: </span>{ currentPhoto.project }</div>
              : null
            }
            <button className="close" onClick={ this.close }>
              <i className="icon-close"></i>
            </button>
          </header>
          <div className="current" style={ currentPhotoStyle }></div>
          <div className="buffered"></div>
          <footer className="controls">
            <div className="caption">{ caption }</div>
            {
              areControlButtonsVisible ?
              <div className="control-buttons">
                <button className="previous" onClick={ this.previous }>
                  <i className="icon-keyboard_arrow_left"></i>
                </button>
                <button className="next" onClick={ this.next }>
                  <i className="icon-keyboard_arrow_right"></i>
                </button>
              </div>
              : null
            }

          </footer>
        </div>
      </div>
    );
  }
}

export default Gallery;



// WEBPACK FOOTER //
// ./src/Gallery/Gallery.js